import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

export const MobileCartBar = ({ count, total, onCheckout, disabled, cartId, testid = "mobile-cart-bar" }) => {
  if (!count) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-card/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_rgba(0,0,0,0.35)] backdrop-blur lg:hidden" data-testid={testid}>
      <div className="flex items-center gap-3">
        <button type="button" className="flex min-w-0 flex-1 items-center gap-3 text-left" onClick={() => document.getElementById(cartId)?.scrollIntoView({ behavior: "smooth", block: "start" })} data-testid={`${testid}-open`}>
          <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary">
            <ShoppingCart className="h-5 w-5" />
            <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 font-mono text-[11px] font-bold text-primary-foreground" data-testid={`${testid}-count`}>{count}</span>
          </span>
          <span className="min-w-0">
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground">Toplam</span>
            <span className="block truncate font-heading text-xl font-extrabold text-primary" data-testid={`${testid}-total`}>{total}</span>
          </span>
        </button>
        <Button className="h-12 px-6 text-base font-semibold" disabled={disabled} onClick={onCheckout} data-testid={`${testid}-checkout`}>Satışı Tamamla</Button>
      </div>
    </div>
  );
};
